import PrestudyContextProvider from "../../context/Prestudy/PrestudyContextProvider";
import PrestudySplitter from "../PrestudySplitter";

export default function PrestudyComponent() {
    return (
        <PrestudyContextProvider>
            <PrestudySplitter />
        </PrestudyContextProvider>
    )
}